"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormLabel = _interopRequireDefault(require("./FormLabel"));

var _KeyboardUtils = _interopRequireDefault(require("../../util/KeyboardUtils"));

var _underscore = require("underscore");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @callback FormRadioInput~onValueChange
 *
 * @param {string} value
 *    The value of the radio selected.
 * @param {object} e
 *    The ReactJS synthetic event object.
 */

/**
 * @class FormRadioInput
 * @desc A checkbox field component.
 *
 * @param {string} [data-id="FormRadioInput"]
 *    Defines the value of the "data-id" for the top-level component container.
 * @param {string} [className]
 *    CSS class(es) added on the top-level component container.
 *
 * @param {boolean} [autoFocus=false]
 *     Whether or not to auto-focus the element.
 * @param {boolean} [checked]
 *    Whether or not the radio input is selected.
 * @param {FormRadioInput~onValueChange} [onValueChange]
 *    Callback to be triggered when the radio input is toggled.
 * @param {string} [label]
 *    Label text to be displayed.
 * @param {node} [description]
 *    Description to display below the label.
 * @param {string} [helpHintText]
 *    When set, a help icon appears to the right of the label.  This value defines the text to display when the user
 *    hovers over the help icon.
 * @param {string} [name]
 *    The name value for the input.
 * @param {string} [value]
 *    The value for the input.
 *
 * @param {boolean} [disabled]
 *    If true, disables current radio input in both functionality and style.
 *
 * @example
 *
 *     <FormRadioInput
 *         label="Regular Checkbox"
 *         data-id="form-checkbox"
 *         onValueChange={this._onChangeCallback}
 *     />
 *
 */
var FormRadioInputBase = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FormRadioInputBase, _React$Component);

  var _super = _createSuper(FormRadioInputBase);

  function FormRadioInputBase() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, FormRadioInputBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleValueChange", function (e) {
      _this.props.onValueChange(_this.props.value, e);
    });
    return _this;
  }

  (0, _createClass2.default)(FormRadioInputBase, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        className: (0, _classnames.default)("input-radio", {
          "no-label": !this.props.label && !this.props.helpHintText
        }, {
          disabled: this.props.disabled
        }, this.props.className),
        key: this.props.value,
        "data-id": this.props["data-id"] + "_label_" + this.props.value,
        value: this.props.label,
        hint: this.props.helpHintText,
        description: this.props.description
      }, /*#__PURE__*/_react.default.createElement("input", {
        "data-id": this.props["data-id"] + "_" + this.props.value,
        type: "radio",
        name: this.props.name,
        value: this.props.value,
        checked: this.props.checked,
        onChange: this._handleValueChange,
        disabled: this.props.disabled,
        autoFocus: this.props.autoFocus
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "circle"
      }));
    }
  }]);
  return FormRadioInputBase;
}(_react.default.Component);

(0, _defineProperty2.default)(FormRadioInputBase, "propTypes", {
  "data-id": _propTypes.default.string,
  checked: _propTypes.default.bool,
  autoFocus: _propTypes.default.bool,
  className: _propTypes.default.string,
  description: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  label: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object, _propTypes.default.string]),
  labelNode: _propTypes.default.node,
  onValueChange: _propTypes.default.func,
  name: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
});
(0, _defineProperty2.default)(FormRadioInputBase, "defaultProps", {
  "data-id": "FormRadioInput",
  autoFocus: false,
  onValueChange: _underscore.noop
});

var FormRadioInput = _KeyboardUtils.default.withFocusOutline(FormRadioInputBase);

var _default = FormRadioInput;
exports.default = _default;
module.exports = exports["default"];